import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import mapboxgl from 'mapbox-gl';
import mapStyles from '../utils/Style';
import {setMap, setMapLoaded, setDirection, placesList} from '../actions'; 
import Map from './Map';
import Sidebar from '../containers/Sidebar';
import MapBox from '../utils/Mapbox';
import MapDirection from './MapDirection';
import '../styles/mapbox-gl.css';
//import images from '../images/';

const { detect } = require('detect-browser');
const browser = detect();

class App extends Component {
    constructor(props){
        super(props);
        this.loaded = false;
        document.body.classList.add(browser.name);
    }
    componentDidMount(){
        // mapboxgl.accessToken = 'pk.eyJ1Ijoibm91cGhhbHBncyIsImEiOiJjajV0YXZxdDIxZmtjMzNwajRjaHo3dzBmIn0.JRJtyy5Epzx6QKmfy5FN7g';
        mapboxgl.accessToken = 'pk.eyJ1IjoidWFldSIsImEiOiJjamJoaG9xcmUybWVlMzN0Yml2eW50cjc4In0.kOrCVz76aaAlPrVVC-Uq2Q';
        const map = new mapboxgl.Map({
            container: 'map',
            maxZoom: 18.5,
            minZoom: 13.5,
            minZoom: 8,
            zoom: 15,
            center: [55.678677781457054, 24.198490356012897],
            style: mapStyles,
            hash: false
        });
        
        /*
        map.addControl(new MapboxDirections({
            accessToken: mapboxgl.accessToken
        }), 'top-left');*/

        map.addControl(new mapboxgl.NavigationControl());
        map.dragRotate.disable();
        
        this.props.setMap(map);
        this.renderMap(map)
    }

    renderMap(mapData){
        let geoData = this.props.geoData,
            map = mapData,
            iconsArr = [],
            categoryArr = [];
            
        map.on('load', (e) => {
            if(map.getSource('points') === undefined){
                map.addSource("points", {
                    "type": "geojson",
                    "data": geoData
                });
            }

            const img_base_url = 'https://www.uaeu.ac.ae/images/map/';
            
            geoData.features.map((feature, i) => {
                var symbol = feature.properties['icon'];
                var url_trim = symbol.replace(/-/g,'');
                
                var location_img = ((browser.name === 'ie' || browser.name === 'edge') && symbol) ? img_base_url + symbol + '.png' : require('../images/' + symbol + '.png');
               
                map.loadImage( location_img, function(error, image) {
                    if (error) throw error;
                    if (!iconsArr.includes(symbol)) {
                        map.addImage(symbol, image);
                        iconsArr.push(symbol);
                    }
                    if (!map.getLayer('uaeu')) {
                        map.addLayer({
                            "id": 'uaeu',
                            "type": "symbol",
                            "source": "points",
                            "layout": {
                                "visibility": "none",
                                "icon-image": "{icon}",
                                "icon-size": 0.7,
                                "icon-allow-overlap": true,
                            }
                        });
                    }
                });
                //this.props.setMapLoaded(true);
            });

            /*var point_img = browser.name === 'ie' || browser.name === 'edge' ? img_base_url + 'point.png' : require('../images/point.png');

            map.loadImage(point_img, function(error, image) {
                if (error) throw error;
                map.addImage('point', image);
            });*/

        });  

        if(browser.name === 'ie' || browser.name === 'edge' ){
            var uaeuCheck = setInterval(() => {
                if(!map.getLayer('uaeu')){
                    if(map.getSource('points') === undefined){
                        map.addSource("points", {
                            "type": "geojson",
                            "data": geoData
                        });
                        
                        const img_base_url = 'https://www.uaeu.ac.ae/images/map/';
                        
                        geoData.features.map((feature, i) => {
                            var symbol = feature.properties['icon'];
                            var url_trim = symbol.replace(/-/g,'');
                            
                            var location_img = img_base_url + symbol + '.png';

                            
                            map.loadImage( location_img, function(error, image) {
                                if (error) throw error;
                                if (!iconsArr.includes(symbol)) {
                                    map.addImage(symbol, image);
                                    iconsArr.push(symbol);
                                }
                                if (!map.getLayer('uaeu')) {
                                    map.addLayer({
                                        "id": 'uaeu',
                                        "type": "symbol",
                                        "source": "points",
                                        "layout": {
                                            "visibility": "none",
                                            "icon-image": "{icon}",
                                            "icon-size": 0.7,
                                            "icon-allow-overlap": true,
                                        }
                                    });
                                }
                            });
                        });
            
                       /* var point_img = img_base_url + 'point.png';

                        map.loadImage(point_img, function(error, image) {
                            if (error) throw error;
                            map.addImage('point', image);
                        }); */

                    }

                   
                }else{
                    clearInterval(uaeuCheck);
                }
            }, 2000);
        }
            
        map.on('mouseenter', 'uaeu', function(e) {
            MapBox.toolTip(e);
            map.getCanvas().style.cursor = 'pointer';
        });
        
        map.on('mousemove', 'uaeu', function(e) {
            let tooltip = document.getElementsByClassName('tooltip')[0];
            if(tooltip){
                tooltip.setAttribute('style', `left: ${e.point.x}px; top: ${e.point.y}px;`);
            }
        });


        map.on('mouseleave', 'uaeu', function(e) {
            var mapDiv = document.getElementById('map');
            var tooltip = document.getElementsByClassName('tooltip')[0];
            if (tooltip) {
                mapDiv.removeChild(tooltip);
            }

            map.getCanvas().style.cursor = '';
        });
        
        map.on('click', (e) => {
            if(!map.isSourceLoaded('points')){
                window.location.reload();
            }
        });

        map.on('click', 'uaeu', function(e) {
            var mapDiv = document.getElementById('map');
            var tooltip = document.getElementsByClassName('tooltip')[0];
            if (tooltip) {
                mapDiv.removeChild(tooltip);
            }
            MapBox.popUp(e, map);
        });

        map.on('render', (e) => {
            if(map.style._loaded){
                document.body.classList.add("mapLoaded");

                if(!this.props.mapLoaded){
                   this.props.setMapLoaded(true);
                   document.getElementById('mapVisuals').click();
                    
                }
                

                
                if(map.getLayer('uaeu') != undefined  && this.props.mapLoaded){
                    
                    if(!this.loaded){
                        if ("ontouchstart" in document.documentElement){
                            document.body.classList.add("touchDevice");
                        }

                        document.getElementById('mapVisuals').click();
                        this.loaded = true;





                        var query = window.location.search;
                        query = query.replace('?','');
                        if(query){

                            var locations = this.props.geoData.features;
                            var filtered = locations.filter(function(location) {
                                    var id = location.properties.id.trim().toLowerCase();
                                return id.indexOf(query) > -1;
                            });
                    
                            if(filtered.length > 0){

                                map.setFilter('uaeu', ['in', 'id'].concat(filtered[0].properties.id));
                                map.flyTo({
                                    center: filtered[0].geometry.coordinates,
                                    speed: 0.5,
                                    zoom: 15.6
                                });
                                map.setLayoutProperty('uaeu', 'visibility', 'visible');
                                MapBox.popUp(filtered[0], map);
                            }
                            
                        }


                        setTimeout(() => {
                            document.body.classList.add("mapLoaded");
                            let loader = document.getElementById('loader');
                            if(loader){
                                loader.setAttribute('class', 'hide-loader');
                            }
                        }, 100);
                    }
                }
            }
        });
    }

    render(){
        let mapDirection = null;
        if(this.props.mapDirection){
            mapDirection = <MapDirection locationList={this.props.locationList} setLocation={this.props.placesList} map={this.props.map}/>
        }
        return(
            <div className={`map-inner ${browser.name}`}>
                <div id="loader">
                    <div>
                        <p>Use Google Chrome for better Performance and User Experience.</p>
                    </div>
                </div>
                <Sidebar />
                <main id="map" aria-label="Campus map"></main>
                {mapDirection}
            </div>
        )
    }
}



const mapStateToProps = (state) => {
   return{
        geoData : state.mapData,
        map : state.map,
        mapLoaded : state.mapLoaded,
        mapDirection : state.mapDirection,
        locationList : state.locationList
    }    
}    

const mapDispatchToProps = (dispatch) => {
    return {
        setMap : bindActionCreators(setMap, dispatch),
        setMapLoaded : bindActionCreators(setMapLoaded, dispatch),
        setDirection : bindActionCreators(setDirection , dispatch),
        placesList : bindActionCreators(placesList , dispatch)
    }    
}    

export default connect(mapStateToProps, mapDispatchToProps)(App);





// WEBPACK FOOTER //
// ./src/components/App.js